import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Login.css';
import Logo from '../assets/icons/pitchers.png';
import api from '../config/axios';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const resetToken = location.state?.resetToken;

  // If no reset token, redirect to forgot password
  if (!resetToken) {
    navigate('/forgot-password');
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await api.post('/auth/reset-password', {
        resetToken,
        newPassword
      });
      setMessage(response.data.message);
      // Redirect to login after successful reset
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-form-container">
          <div className="login-logo">
            <img src={Logo} alt="Pitchers" />
            <h2>Pitchers</h2>
          </div>
          <h1>Reset Password</h1>
          <p className="forgot-description">
            Enter your new password below.
          </p>
          {message && <p style={{ color: 'green' }}>{message}</p>}
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                placeholder="Enter your new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>
            <div className="form-group">
              <label>Confirm New Password</label>
              <input
                type="password"
                placeholder="Confirm your new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>
            <button 
              type="submit" 
              className="login-button"
              disabled={loading}
            >
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
            <div className="signup-prompt">
              Return to <Link to="/login">Sign in</Link>
            </div>
          </form>
        </div>
      </div>
      <div className="login-right">
        <img src={require('../assets/background/image.png')} alt="background" className="background-image" />
        <div className="promo-content">
          <div className="promo-text">
            <h2>Create a new</h2>
            <h2>secure password</h2>
            <h2>for your <span>Pitchers</span></h2>
            <h2><span>account</span></h2>
          </div>
          <p>
            Choose a strong password that you haven't used before. A good password is at least 8 characters long and includes a mix of uppercase, lowercase, numbers, and symbols.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword; 